import { Step } from 'react-joyride';

const getAbsencesTourSteps = (
  _isMobile: boolean,
  hayPendientes: boolean
): Step[] => {
  const allSteps: (Step & { needsPending?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a la sección de <strong>Ausencias</strong>. Aquí gestionas
          las solicitudes de ausencia de tus trabajadores (vacaciones, bajas,
          días libres…) y consultas el histórico de las ya aprobadas o
          rechazadas.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-pendientes-section',
      content: (
        <div style={{ textAlign: 'justify' }}>
          En esta sección aparecen todas las{' '}
          <strong>solicitudes pendientes</strong>, las que aún no has aprobado
          ni rechazado. Cada tarjeta muestra el trabajador, el tipo de ausencia
          y las fechas solicitadas.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '.tour-aprobar-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Aprobar</strong> para aceptar una solicitud. Los días
          quedarán bloqueados en el calendario del trabajador y no se le podrán
          asignar citas en esas fechas.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
      needsPending: true,
    },
    {
      target: '.tour-rechazar-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Rechazar</strong> para denegar una solicitud. Se te
          pedirá un <strong>motivo</strong>, que el trabajador podrá ver, para
          que entienda por qué no se le ha concedido.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
      needsPending: true,
    },
    {
      target: '.tour-historico-section',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Aquí tienes el <strong>histórico de ausencias</strong> ya resueltas:
          aprobadas y rechazadas. Cada una muestra su estado, las fechas y los
          días laborables que abarca (descontando fines de semana y festivos).
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: '.tour-historico-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este campo para <strong>filtrar el histórico</strong> por nombre
          del trabajador, correo o tipo de ausencia (vacaciones, baja médica,
          etc.).
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-reabrir-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Reabrir</strong> para devolver una ausencia ya resuelta
          al estado <em>pendiente</em>. Útil si te equivocaste al aprobar o
          rechazar, o si cambian las circunstancias.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si hay muchas ausencias en el histórico, usa la{' '}
          <strong>paginación</strong> para moverte entre páginas.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Al rechazar una ausencia se abre un pequeño formulario donde{' '}
          <strong>indicas el motivo</strong> del rechazo. Escríbelo de forma
          clara: es el mensaje que verá el trabajador para entender la decisión.
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(s.needsPending && !hayPendientes))
    .map(({ needsPending, ...step }) => step);
};

export default getAbsencesTourSteps;